import { BusinessSource, UpdateBusinessSource } from '@/entities/businessSource';
import { useEffect, useState } from 'react';
import { BusinessSourceService } from '@/services/BusinessSourceService';
import { tr } from 'date-fns/locale';

export const useBusinessSource = () =>{
  const [businessSources, setBusinessSource] = useState<BusinessSource[]>([]);
  const [searchedBusinessSources, setSearchedBusinessSources] = useState<BusinessSource[]>([]);
  const [errorFetchBusinessSource, setErrorFetchBusinessSources] = useState(false);
  const [searchedBusinessSourceError, setSearchedBusinessSourceError] = useState(false);
  const [errorSaveBusinessSource, setErrorSaveBusinessSource] = useState(false);
  const [errorDeleteBusinessSource, setErrorDeleteBusinessSource] = useState(false);
  const [errorCreateBusinessSource, setErrorCreateBusinessSource] = useState(false);

  useEffect(()=>{
    const fetchBusinessSource = async ()=>{
      try{
        const response = await BusinessSourceService.getBusinessSourceService();
        if(response){
          const businessSource = response.map((data:any)=>({
            id: data.id,
            description: data.description
          }));
          setBusinessSource(businessSource);
        }
      }catch(error){
        console.error(`Falha ao carregar os dados: ${error}`);
        setErrorFetchBusinessSources(true);
      }
    };

    fetchBusinessSource();
  }, []);

  const saveBusinessSource = async (businessSource:UpdateBusinessSource[]) => {
    try{
      await BusinessSourceService.updateOrCreateBusinessSource(businessSource);
    }catch(error){
      console.error(`Falha ao atualizar os dados: ${error}`);
      setErrorSaveBusinessSource(true);
    }
  };

  const deleteBusinessSource = async (id: number) => {
    try {
      await BusinessSourceService.deleteBusinessSource(id);
    }catch(error){
      console.error(`Falha ao apagar os dados: ${error}`);
      setErrorDeleteBusinessSource(true);
    }
  };

  const searchBusinessSource = async (contain:string) => {
    try{
      const response = await BusinessSourceService.searchBusinessSource(contain);
      if(response){
        setSearchedBusinessSources(response);
      }
    }catch(error){
      console.error(`Falha ao buscar os dados: ${error}`);
      setSearchedBusinessSourceError(true);
    }
  };

  const createBusinessSource = async (businessSource:BusinessSource) => {
    try{
      await BusinessSourceService.createBusinessSourceService(businessSource);
    }catch(error){
      console.error(`Falha ao criar os dados: ${error}`);
      setErrorCreateBusinessSource(true);
    }
  };

  return {
    businessSources,
    searchedBusinessSources,
    searchBusinessSource,
    deleteBusinessSource,
    saveBusinessSource,
    createBusinessSource
  };
  
};

